import { ThemeOptions } from '@material-ui/core'
import Axios from 'axios'
import React from 'react'
import { useAppDispatch } from 'store/configureStore'
import { SetAppTheme } from 'store/Application/appActions'
import { TelemetryService } from 'services/Telemetry'
import { newUserActions } from 'store/User/newUserReducer'

enum EmbeddedRh24MessageTypes {
  RH24_EMBEDDED_SETUP = 'RH24_EMBEDDED_SETUP',
}

interface IEmbeddedRh24Message {
  type: EmbeddedRh24MessageTypes
  theme: ThemeOptions
  partyId: string
}

const messageHandler =
  (dispatch) => (ev: MessageEvent<IEmbeddedRh24Message>) => {
    if (ev.data?.type === EmbeddedRh24MessageTypes.RH24_EMBEDDED_SETUP) {
      console.info('starting self-service portal', ev.data)

      dispatch(SetAppTheme({ ...ev.data.theme }))
      if (ev.data['partyId']) {
        Axios.defaults.headers['MH-Tenant'] = ev.data.partyId

        TelemetryService.getInstance().TrackEvent('SelfServicePortalStarted', {
          tenantId: ev.data.partyId,
        })

        dispatch(newUserActions.setTenantId(ev.data.partyId))
      } else {
        console.error('no partyId provided, tenant header not set')
        TelemetryService.getInstance().logError(
          new Error('no partyId provided, tenant header not set')
        )
      }
    }
  }

export const EmbeddedRh24 = () => {
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    if (window.self !== window.top) {
      window.addEventListener('message', messageHandler(dispatch))
      return () =>
        window.removeEventListener('message', messageHandler(dispatch))
    }

    return null
  }, [dispatch])

  return null
}
